var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-container d-flex flex-column" },
    [
      _c("simple-header"),
      _vm._v(" "),
      _c("div", { staticClass: "error-content" }, [
        _c(
          "div",
          { staticClass: "row m-0" },
          [
            _c(
              "div",
              { staticClass: "col-lg-4 image-col" },
              [
                _c(
                  "transition",
                  {
                    attrs: {
                      name: "bounce",
                      "enter-active-class": "bounceInLeft"
                    }
                  },
                  [
                    _vm.showWithDelay
                      ? _c("img", {
                          attrs: {
                            src: require("../assets/image/error_pages/500.png"),
                            alt: "error"
                          }
                        })
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "transition",
              {
                attrs: { name: "bounce", "enter-active-class": "bounceInRight" }
              },
              [
                _vm.showWithDelay
                  ? _c("div", { staticClass: "col-lg-8 text-col" }, [
                      _c("h1", [_vm._v("Oops... Something went wrong.")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "An error occurred while processing the request."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.message))]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "error-btn px-3",
                          attrs: { role: "link" },
                          on: {
                            click: function($event) {
                              return _vm.navigateToLanding()
                            }
                          }
                        },
                        [_vm._v("GO TO AUTODESK ONE HOME")]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b73ad92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b73ad92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = null
// module chunks = 